import { useState, useEffect } from 'react'

export const useFetchAllCashiers = ({marvarApi, dispatch, onLogout}) => {

    // 1. Para los datos recuperados de la BD
    const [ dataCashiers, setDataCashiers ] = useState([])
    
    // 2. Para mostrar animación de carga
    const [ loadingFetchAllCashiers, setLoadingFetchAllCashiers ] = useState(false)

    // 3. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            
            const response = await marvarApi.get(`/caja/get-all-cajas`)
            // console.log('cajas ::::: ', response.data)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        setLoadingFetchAllCashiers(true)
        fetchData()
            .then((resp) => {
                setDataCashiers(resp.rows)
                setLoadingFetchAllCashiers(false)
            })
            .catch(e => {
                console.log(e, '________ERROR')
                setLoadingFetchAllCashiers(false)
            })
    }, [execute])

    return {  dataCashiers, loadingFetchAllCashiers , executeFetch }

}

export const useFetchSpecificCashier = ({marvarApi, dispatch, onLogout, Forms}) => {

    // 1. Para los datos recuperados de la BD
    // const [infoClient, setInfoClient] = useState([])
    const { FormScreen } = Forms
    const { setFormState } = FormScreen
    
    // 2. Para mostrar animación de carga
    const [ loadingFetchSpecificCashier, setLoadingFetchSpecificCashier ] = useState(false)

    // 3. Para setear parametros de búsqueda al fetch
    const [paramsToSearch, setParamsToSearch] = useState({idcaja: ''})

    // 4. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        try {
            
            const response = await marvarApi.get(`/caja/get-specific-caja/${paramsToSearch.idcaja}`)
            // console.log('[useFetchData][useFetchSpecificCashier] response.data ::: ', response.data)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if(paramsToSearch.idcaja > 0 ){
            setLoadingFetchSpecificCashier(true)
            fetchData()
                .then((resp) => {
                    
                    // Setea en el estado del formulario los datos del registro
                    const { rows } = resp
                    setFormState((prevState) => ({
                        ...prevState,
                        idcategoria: rows[0].idcategoria || '',
                        idcaja: rows[0].idcaja || '',
                        descripcion_corta: rows[0].descripcion_corta || '',
                        descripcion_larga: rows[0].descripcion_larga || '',
                        currency_type: rows[0].currency_type || '',
                        retirable: rows[0].retirable || ''
                    }))
                    setLoadingFetchSpecificCashier(false)

                })
                .catch(e => {
                    console.log(e, '________ERROR')
                    setLoadingFetchSpecificCashier(false)
                })
        }
    }, [execute])

    return { loadingFetchSpecificCashier, setParamsToSearch, executeFetch }

}

export const useFetchCategories = ({marvarApi, dispatch, onLogout}) => {

    // 1. Para los datos recuperados de la BD
    const [ dataCategories, setDataCategories ] = useState([])
    
    // 2. Para mostrar animación de carga
    const [ loadingFetchAllCategories, setLoadingFetchAllCategories ] = useState(false)

    // 3. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            
            const response = await marvarApi.get(`/caja/categories`)
            console.log('[useFetch][useFetchCategories] response.data :::', response.data)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        setLoadingFetchAllCategories(true)
        fetchData()
            .then((resp) => {
                setDataCategories(resp.rows)
                setLoadingFetchAllCategories(false)
            })
            .catch(e => {
                console.log(e, '________ERROR')
                setLoadingFetchAllCategories(false)
            })
    }, [execute])

    return {  dataCategories, loadingFetchAllCategories , executeFetch }

}